/// <reference path="../include.ts" />

namespace project_guide {

	import View = alm.view.View;
	import Lang = project_common.Lang;
	import Dom = alm.util.Dom;
	import DataParser = project_common.DataParser;
	import Application = project_common.Application;
	import DomUtil = project_common.DomUtil;
	import GuideListBanner = project_common.GuideListBanner;

	export class BannerContainer extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
			super(jQuery('#banner-container'));
			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view = this.getView();

			// reset
			this.clearContext();

			return view;
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Command();
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Command();
		}





		public clearContext():void {
			this.getView().empty();
		}

		public setContext():void {
			this.clearContext();
			const lang = Application.getPresetContext().lang;
			const bannerData = Application.getBannerData().guide;

			// banner
			const itemContainer = this.getView();
			const itemDataList = bannerData.list;
			const itemCount = itemDataList.length;
			for (let i = 0; i < itemCount; ++i) {
				const item = this.createBanner(itemDataList[i], lang);
				if (item) {
					itemContainer.append(item);
				}
			}
		}

		private createBanner(data:GuideListBanner, lang:Lang):JQuery {
			try {
				const view = jQuery(Dom.instantiate('small-banner-item-template'));

				// title
				DomUtil.setHtml(view.find('.header .title'), DataParser.localize(data.title, lang));

				// description
				DomUtil.setHtml(view.find('.description .text'), DataParser.localize(data.description, lang));

				// main image
				view.find('.grid-image img').attr('src', DataParser.localize(data.coverImageUrl, lang));

				// app info
				const app = view.find('.app');
				DomUtil.setHtml(app.find('.text'), DataParser.localize(data.appName, lang));
				app.find('.icon img').attr('src', DataParser.localize(data.appIconImageUrl, lang));

				// link
				{
					const itemContainer = view.find('.link-container');
					const itemDataList = data.links;
					const itemCount = itemDataList.length;
					for (let i = 0; i < itemCount; ++i) {
						const item = BindingUtil.createBannerLink(itemDataList[i], lang);
						itemContainer.append(item);
					}
				}

				return view;

			} catch (error:any) {
				trace('[BannerContainer] banner (list view) : invalid data, data =', data, ', error =', error);
				return null;
			}
		}





		// --------------------------------------------------
		//
		// MEMBER
		//
		// --------------------------------------------------

		public static getInstance():BannerContainer { return this.instance || (this.instance = new BannerContainer()) };
		private static instance:BannerContainer = null;
	}
}
